
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';


@Injectable({
    providedIn: 'root',
})
export class AwardService {
    private selectedAwardVersion: any;

    constructor(private http: HttpClient) { }

    getAwardsHome(): Observable<any> {
        const url = environment.apiURL + `api/api/cinejoy/awards/home`
        return this.http.get(url);
    }

    getAllAwardsWinner():Observable<any>{
        const url = environment.apiURL + `api/api/cinejoy/awards/currentwinners`;
        return this.http.get(url);
    }

    getAllCurrentJury():Observable<any>{
        const url = environment.apiURL + `api/api/cinejoy/awards/currentjury`;
        return this.http.get(url);
    }

    getAllBanners():Observable<any>{
        const url = environment.apiURL + `api/api/cinejoy/awards/banner`;
        return this.http.get(url);
    }

    getAllWinners():Observable<any>{
        const url = environment.apiURL + `api/users/account/winners`;
        return this.http.get(url);
    }

    getAllAwardsVersion():Observable<any>{
        const url = environment.apiURL + `api/api/users/account/getallawardsversion`;
        return this.http.get(url);
    }

    getAllJudgesList():Observable<any>{
        const url = environment.apiURL + `api/api/cinejoy/awards/judgeslist`;
        return this.http.get(url);
    }

    modifyAwardsVersion(id:any):Observable<any>{
        const url = environment.apiURL + `api/api/users/account/modifyawardversion/${id}`
        return this.http.post(url, {});
    }

    deleteAwardsVersion(id:any):Observable<any>{
        const url = environment.apiURL + `api/api/users/account/deleteawardversion/${id}`
        return this.http.delete(url);
    }

    addAwardsVersion(value:any):Observable<any>{
        const url = environment.apiURL + `api/api/users/account/addawardsversion?awardsversion=${value}`
        return this.http.post(url, {});
    }

    addAwardsBanner(userId, obj, formdata):Observable<any>{
        let url = environment.apiURL + `api/api/users/${userId}/account/addnewawardbanner`
        delete obj.thumbnail;
        delete obj.mobile_thumbnail;
        let urlprams = new URLSearchParams(obj).toString();
        url = url +'?'+ urlprams;
        return this.http.post(url, formdata)
    }

    addAwardsWinner(userId, obj, formdata):Observable<any>{
        let url = environment.apiURL + `api/users/${userId}/account/addnewawardwinner`
        delete obj.thumbnail;
        delete obj.mobile_thumbnail;
        let urlprams = new URLSearchParams(obj).toString();
        url = url +'?'+ urlprams;
        return this.http.post(url, formdata)
    }

    addAwardsJury(userId, obj, formdata):Observable<any>{
        let url = environment.apiURL + `api/users/${userId}/account/addnewawardjury`
        delete obj.thumbnail;
        let urlprams = new URLSearchParams(obj).toString();
        url = url +'?'+ urlprams;
        return this.http.post(url, formdata);
    }

    deleteAwardsWinner(userId, id:any):Observable<any>{
        const url = environment.apiURL + `api/api/users/${userId}/account/deleteawardwinner/${id}`
        return this.http.delete(url, {});
    }

    deleteAwardsBanner(userId, id:any):Observable<any>{
        const url = environment.apiURL + `api/api/users/${userId}/account/deleteawardbanner/${id}`
        return this.http.delete(url);
    }

    deleteAwardsJury(userId, id:any):Observable<any>{
        const url = environment.apiURL + `api/api/users/${userId}/account/deleteawardjury/${id}`
        return this.http.delete(url, {});
    }

    modifyAwardsWinner(userId,id, obj, formdata):Observable<any>{
        let url = environment.apiURL + `api/users/${userId}/account/modifyawardwinner/${id}`;
        delete obj.thumbnail;
        delete obj.mobile_thumbnail;
        let urlprams = new URLSearchParams(obj).toString();
        url = url +'?'+ urlprams;
        return this.http.post(url, formdata);
    }

    modifyAwardsBanner(userId,id, obj, formdata):Observable<any>{
        let url = environment.apiURL + `api/users/${userId}/account/modifyawardbanner/${id}`
        delete obj.thumbnail;
        delete obj.mobile_thumbnail;
        let urlprams = new URLSearchParams(obj).toString();
        url = url +'?'+ urlprams;

        return this.http.post(url, formdata);
    }

    modifyAwardsJury(userId,id, obj, formdata):Observable<any>{
        let url = environment.apiURL + `api/users/${userId}/account/modifyawardjury/${id}`
        delete obj.thumbnail;
        delete obj.mobile_thumbnail;
        let urlprams = new URLSearchParams(obj).toString();
        url = url +'?'+ urlprams;

        return this.http.post(url, formdata);
    }

    postAwardsVersion(value:any):Observable<any>{
        const url = environment.apiURL + `api/api/users/account/addawardsversion?awardsversion=${value}`
        return this.http.post(url, {});
    }

    getAllJuryByVersion(value:any):Observable<any>{
        const url = environment.apiURL + `api/api/cinejoy/awards/archivedjury/${value}`
        return this.http.get(url);
    }

    getAllWinnersByVersion(version:any):Observable<any>{
        const url = environment.apiURL + `api/api/cinejoy/awards/archivedwinners/${version}`
        return this.http.get(url);
    }

    getArchivedWinnersByVersion(version:any):Observable<any>{
        const url = environment.apiURL + `api/api/cinejoy/awards/archivedwinners/${version}`;
        return this.http.get(url);
    }

    getArchivedJuryByVersion(version:any):Observable<any>{
        const url = environment.apiURL + `api/api/cinejoy/awards/archivedjury/${version}`;
        return this.http.get(url);
    }

    getArchivedHomePageByVersion(version:any):Observable<any> {
        const url = environment.apiURL + `api/api/cinejoy/awards/archivedversions/${version}`
        return this.http.get(url);
    }

    setVersion(version: any) {
        this.selectedAwardVersion = version;
    }
    
    getVersion() {
        return this.selectedAwardVersion;
    }

}

